<template>
    <el-dialog :title="title + '租户套餐'" width="40%" :close-on-click-modal="false" append-to-body :visible.sync="visible">
        <el-form size="small" :model="form" ref="form" label-width="160px" :rules="dataRule" v-loading="loading"
                 :disabled="method==='view'">
            <el-form-item label="套餐名称：" prop="setMealName">
                <el-input v-model.trim="form.setMealName" placeholder="请输入套餐名称（限20字）" clearable
                          maxlength="20"></el-input>
            </el-form-item>
            <el-form-item label="套餐权限：" prop="menuIds">
                <el-checkbox class="m_b1" v-model="unfold" @change="toggleUnfold">展开/折叠</el-checkbox>
                <el-checkbox class="m_b1" v-model="checkAll" @change="toggleCheckAll">全选/全不选</el-checkbox>
                <el-tree
                        :data="menuList"
                        :props="defaultProps"
                        node-key="id"
                        ref="menuListTree"
                        show-checkbox>
                </el-tree>
            </el-form-item>
            <el-form-item label="状态：" prop="status">
                <el-radio-group v-model="form.status" :disabled="tenantSetMealStatus == '1'">
                    <el-radio label="0">启用</el-radio>
                    <el-radio label="1">禁用</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="备注：" prop="remark">
                <el-input
                        type="textarea"
                        :rows="3" maxlength="200" resize="none"
                        placeholder="请输入备注(限200字)"
                        v-model.trim="form.remark">
                </el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="p_b1">
            <el-button size="small" @click="visible = false">取消</el-button>
            <el-button size="small" type="primary" @click="doSubmit()" v-noMoreClick>确定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        data() {
            return {
                id: '',
                visible: false,
                loading: false,
                title: '',
                method: '',
                form: {
                    id: '',
                    setMealName: '',
                    menuIds: '',
                    status: '0',
                    remark: '',
                },
                tenantSetMealStatus: 0,
                unfold: false,
                checkAll: false,
                defaultProps: {
                    label: 'name',
                    children: 'children',
                },
                menuList: [],
                dataRule: {
                    setMealName: [
                        {required: true, message: '套餐名称不能为空', trigger: 'blur'}
                    ],
                    menuIds: [
                        {required: true, message: ' ', trigger: 'blur'}
                    ],
                    status: [
                        {required: true, message: '状态不能为空', trigger: 'change'}
                    ],
                },
                // 删除
                delInfoFlag: false
            }
        },
        methods: {
            init(row, method) {
                this.tenantSetMealStatus = 0
                this.unfold = false
                this.checkAll = false
                this.method = method
                if (method === 'add') {
                    this.title = `新增`
                } else if (method === 'edit') {
                    this.title = '修改'
                } else if (method === 'view') {
                    this.title = '查看'
                }
                this.visible = true
                this.$nextTick(() => {
                    this.getMenu()
                    this.$refs.menuListTree.setCheckedKeys([])
                    this.$refs.form.resetFields();
                    if (row) {
                        this.form.id = row.id
                    } else {
                        this.form.id = ''
                    }
                })
            },
            // 获取详情信息
            getInfo() {
                this.$axios(this.api.user.tenantSetMealGetById + '/' + this.form.id).then(data => {
                    if (data.status) {
                        this.form = this.recover(this.form, data.data)
                        this.tenantSetMealStatus = data.data.tenantSetMealStatus
                        let ids = this.form.menuIds.split(',')
                        this.$nextTick(() => {
                            ids.forEach(value => {
                                this.$refs.menuListTree.setChecked(value, true, false)
                            })
                        })
                    } else {
                        this.$message.error('查询失败')
                    }
                })
            },
            // 获取所有菜单
            getMenu() {
                this.$axios(this.api.user.findAllMenu, {}, 'get').then(data => {
                    if (data.status) {
                        this.menuList = data.data
                        if(this.method != 'add') {
                            this.getInfo()
                        }
                    }
                })
            },
            // 展开/折叠
            toggleUnfold() {
                const tree = this.$refs.menuListTree;
                const nodes = tree.store._getAllNodes(); // 获取所有节点
                nodes.forEach(node => {
                    node.expanded = this.unfold; // 设置展开/折叠状态
                });
            },
            // 全选/全不选
            toggleCheckAll() {
                if (this.checkAll) {
                    const allKeys = this.getAllKeys(this.menuList);
                    this.$refs.menuListTree.setCheckedKeys(allKeys); // 全选
                } else {
                    this.$refs.menuListTree.setCheckedKeys([]); // 全不选
                }
            },
            // 递归获取所有节点的 id
            getAllKeys(data) {
                let keys = [];
                data.forEach(item => {
                    keys.push(item.id);
                    if (item.children && item.children.length) {
                        keys = keys.concat(this.getAllKeys(item.children));
                    }
                });
                return keys;
            },
            // 确定
            doSubmit() {
                let menuIds = this.$refs.menuListTree.getCheckedKeys().concat(this.$refs.menuListTree.getHalfCheckedKeys()).join(',')
                if (!menuIds) {
                    this.$message.error('请选择套餐权限')
                    return
                }
                this.form.menuIds = menuIds
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        this.loading = true
                        this.$axios(this.api.user.tenantSetMealSave, this.form, 'post').then(data => {
                            if (data.status) {
                                this.$message.success('操作成功')
                                this.visible = false
                                this.$emit('refreshDataList')
                            } else {
                                this.$message.error(data.msg)
                            }
                            this.loading = false
                        })
                    }
                })
            },
        }
    }
</script>

<style scoped lang="scss">

</style>
